import React, { useState } from "react";
import useStyles from "../Styles";
import { IconButton, Grid, Box, Tabs, Tab } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { useSelector } from "react-redux";

// Import Sidebars

import ColoradoRiverAccessChartTab from "../../TechnicalView/ColoradoRiverAccess/ColoradoRiverAccessChartTab";
import ColoradoRiverAccessAboutTab from "../../TechnicalView/ColoradoRiverAccess/ColoradoRiverAccessAboutTab";
import PolygonMapChartTab from "../../TechnicalView/PolygonMap/PolygonMapChartTab";
import PolygonMapAboutTab from "../../TechnicalView/PolygonMap/PolygonMapAboutTab";

const AboutSidebar = (props) => {
  const classes = useStyles();
  const { onClose } = props;
  const [tab, setTab] = useState("charts");
  const { chart } = useSelector((state) => state.technical_view);

  const onChangeTab = (_event, value) => {
    setTab(value);
  };

  return (
    <>
      <Box pl={4} pr={4} pt={1}>
        <IconButton className={classes.closeBtn} onClick={onClose}>
          <CloseIcon />
        </IconButton>
        <Grid item xs={12} className={classes.tabs}>
          {
            // chart !== "central_arizona_shortage_impacts" &&
            <Tabs
              value={tab}
              onChange={onChangeTab}
              classes={{
                root: classes.tabRoot,
                indicator: classes.tabIndicator,
              }}
            >
              <Tab
                classes={{
                  root: classes.tabInactive,
                  selected: classes.tabActive,
                }}
                value="charts"
                label="Charts"
                className={classes.startingTab}
              ></Tab>
              <Tab
                classes={{
                  root: classes.tabInactive,
                  selected: classes.tabActive,
                }}
                value="about"
                label="About"
                className={classes.endingTab}
              ></Tab>
            </Tabs>
          }
        </Grid>
      </Box>
      <Box>
        {tab === "about" ? (
          <Grid item xs={12} className={classes.aboutBox}>
            {
              {
                colorado_river_access: <ColoradoRiverAccessAboutTab />,
                access_per_capita: <PolygonMapAboutTab />,
              }[chart]
            }
          </Grid>
        ) : (
          <Grid item xs={12} className={classes.aboutBox}>
            {
              {
                colorado_river_access: <ColoradoRiverAccessChartTab />,
                access_per_capita: <PolygonMapChartTab />,
              }[chart]
            }
          </Grid>
        )}
      </Box>
    </>
  );
};

export default AboutSidebar;
